"use strict";
/**
 * Created by Jonas Wålekvist on 2017-11-09.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetQualityLevel = exports.SpriteSheetNameExtension = exports.DefaultQualityExtension = void 0;
var DefaultQualityExtension;
(function (DefaultQualityExtension) {
    DefaultQualityExtension["LOW"] = "@0.25x.";
    DefaultQualityExtension["MEDIUM"] = "@0.5x.";
    DefaultQualityExtension["HIGH"] = ".";
})(DefaultQualityExtension || (exports.DefaultQualityExtension = DefaultQualityExtension = {}));
var SpriteSheetNameExtension;
(function (SpriteSheetNameExtension) {
    SpriteSheetNameExtension["SPRITE_SHEET_SAME_LAYOUT"] = "_sheetSameLayout.";
    SpriteSheetNameExtension["SPRITE_SHEET"] = "_sheet.";
})(SpriteSheetNameExtension || (exports.SpriteSheetNameExtension = SpriteSheetNameExtension = {}));
var AssetQualityLevel;
(function (AssetQualityLevel) {
    AssetQualityLevel[AssetQualityLevel["META"] = 0] = "META";
    AssetQualityLevel[AssetQualityLevel["LOW"] = 1] = "LOW";
    AssetQualityLevel[AssetQualityLevel["MEDIUM"] = 2] = "MEDIUM";
    AssetQualityLevel[AssetQualityLevel["HIGH"] = 3] = "HIGH";
})(AssetQualityLevel || (exports.AssetQualityLevel = AssetQualityLevel = {}));
//# sourceMappingURL=Asset.js.map